export enum Permission {
  BannersAdminPanel = 'admin_panel.legacy_permission',
}
